export const manifest = {
  screens: {
    scr_lz3h3y: { name: "Finishing Leslie Outreach's Stripe Setup", route: "/", state: {"slideIndex":0}, position: {"x":160,"y":220} },
    scr_needs1: { name: "What you'll need", route: "/", state: {"slideIndex":1}, position: {"x":1560,"y":220} },
    scr_step01: { name: "Sign in to Stripe", route: "/", state: {"slideIndex":2}, position: {"x":2960,"y":220} },
    scr_step02: { name: "Open \"Secure your account\"", route: "/", state: {"slideIndex":3}, position: {"x":4360,"y":220} },
    scr_step03: { name: "Secure your account", route: "/", state: {"slideIndex":4}, position: {"x":5760,"y":220} },
    scr_step3b: { name: "Connect your phone", route: "/", state: {"slideIndex":5}, position: {"x":7160,"y":220} },
    scr_step3c: { name: "Save your backup codes", route: "/", state: {"slideIndex":6}, position: {"x":8560,"y":220} },
    scr_step04: { name: "Add extras: choose the free option", route: "/", state: {"slideIndex":7}, position: {"x":9960,"y":220} },
    scr_step05: { name: "Review and submit", route: "/", state: {"slideIndex":8}, position: {"x":11360,"y":220} },
    scr_step06: { name: "Add the bank account for donations", route: "/", state: {"slideIndex":9}, position: {"x":12760,"y":220} },
    scr_done01: { name: "You're all done!", route: "/", state: {"slideIndex":10}, position: {"x":14160,"y":220} },
  },
  sections: {
    sec_6paaxq: { name: "Stripe Setup Flow", x: 0, y: 0, width: 15520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_6paaxq", children: [
      { kind: "screen", id: "scr_lz3h3y" },
      { kind: "screen", id: "scr_needs1" },
      { kind: "screen", id: "scr_step01" },
      { kind: "screen", id: "scr_step02" },
      { kind: "screen", id: "scr_step03" },
      { kind: "screen", id: "scr_step3b" },
      { kind: "screen", id: "scr_step3c" },
      { kind: "screen", id: "scr_step04" },
      { kind: "screen", id: "scr_step05" },
      { kind: "screen", id: "scr_step06" },
      { kind: "screen", id: "scr_done01" },
    ] },
  ],
}
